import axios from 'axios'
import {BalanceSheetData} from './types'
import {SAMPLE} from './sampleResponse'
const API_URL = process.env.REACT_APP_THEME_API_URL

export const getBalanceSheetData = async (
  company_id: number,
  fy_name: string,
  to_date: string
): Promise<BalanceSheetData | undefined> => {
  try {
    const res = await axios.post(
      `${API_URL}/accounting/transaction/report/balance-sheet/`,
      {
        company_id,
        fy_name,
        from_date: null,
        to_date,
        report_name: 'balance_sheet',
        report_type: null,
      },
      {
        validateStatus: () => true,
      }
    )
    // return SAMPLE

    return res.data
  } catch (error: any) {
    console.log(error)
    if (error.response) throw error.response.data
    // throw error
  }
}
